var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 27.383,
    viewBox: "0 0 20 27.383",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319",
    transform: "translate(0 27.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M19.056-23.772H15.078A5.387,5.387,0,0,0,10-27.383a5.387,5.387,0,0,0-5.078,3.611H.944A.952.952,0,0,0,0-22.824v1.32c0,.01,0,.02,0,.029a.953.953,0,0,0,.944.948H1.3V-2.3A2.313,2.313,0,0,0,3.6,0H16.4a2.313,2.313,0,0,0,2.3-2.3V-20.527h.357A.953.953,0,0,0,20-21.475c0-.01,0-.02,0-.029v-1.32A.952.952,0,0,0,19.056-23.772ZM17.883-2.3A1.473,1.473,0,0,1,16.417-.836H3.6A1.473,1.473,0,0,1,2.131-2.3V-20.385H17.883ZM10-26.553a4.592,4.592,0,0,1,4.2,2.781H5.8A4.587,4.587,0,0,1,10-26.553ZM19.183-21.5a.128.128,0,0,1-.127.127H.944A.128.128,0,0,1,.817-21.5v-1.32a.133.133,0,0,1,.127-.132H19.056a.133.133,0,0,1,.127.132Z",
    fill: "#00b2fc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteItem);
export default __webpack_public_path__ + "static/media/deleteItem.04eef2e1de0bb9f2c61ae3c55956886d.svg";
export { ForwardRef as ReactComponent };